export const getUserPermissions = ticket => {
  return ticket.userPermissions;
};